import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import './utils/reset.css';
//import './utils/style.css';
import './utils/slick.css';
import './utils/slick-theme.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);